import React from 'react'
import * as S from "./tabs16Faces_style"
import FotoObra16Faces from "../../imagens/foto25obra.jpg"
import FotoCores from "../../imagens/cores1.png"

export default function tabs16faces() {
    return (
        <>
            <S.SectionGlobal>
                <S.SectionTabela>
                    <S.DivTabelaTitulo>
                        <p>Tipo</p>
                        <p>Medidas</p>
                        <p>Peças por m²</p>
                        <p>Peso</p>
                        <p>MPA</p>
                    </S.DivTabelaTitulo>
                    <S.DivTabelaConteudo>
                        <p>16 faces 6</p>
                        <p>11,5 x 06 x 22</p>
                        <p>39,5 peças</p>
                        <p>3,1 kg</p>
                        <p>20 a 35</p>
                    </S.DivTabelaConteudo>
                    <S.DivTabelaConteudo>
                        <p>16 faces 8</p>
                        <p>11,5 x 08 x 22</p>
                        <p>39,5 peças</p>
                        <p>4,5 kg</p>
                        <p>20 a 35</p>
                    </S.DivTabelaConteudo>
                    <S.DivTabelaConteudo>
                        <p>16 faces 10</p>
                        <p>11,5 x 10 x 22</p>
                        <p>39,5 peças</p>
                        <p>5,4 kg</p>
                        <p>35</p>
                    </S.DivTabelaConteudo>
                    <S.DivAplicacoes>
                        <p>Aplicações recomendadas:</p>
                        <ul>
                            <li>Pedestres (6cm de espessura)</li>
                            <li>Veículos leves (6cm de espessura)</li>
                            <li>Caminhôes de até três eixos (6cm a 8cm de espessura)</li>
                            <li>Carretas de seis eixos (8cm a 10cm de espessura)</li>
                            <li>Veículos Especiais (8cm a 10cm de espessura)</li>
                        </ul>
                    </S.DivAplicacoes>
                    <S.ImgCores src={FotoCores} alt="cores" />
                    
                </S.SectionTabela>
                <S.Img16Faces src={FotoObra16Faces} alt="obra" />
            </S.SectionGlobal>
        </>
    )
}